import { mapValues } from 'lodash';

function paymentWidgetMigration(paymentWidget) {
  if (paymentWidget.widgetType !== 'Payment' ||
  paymentWidget.config.paymentMethodLabel !== undefined) {
    return paymentWidget;
  }

  return {
    ...paymentWidget,
    config: {
      ...paymentWidget.config,
      paymentMethodLabel: 'EventWidgets_PaymentWidget_SelectPaymentMethod__resx'
    }
  };
}

export default function v40(website) {
  return {
    ...website,
    eventVersion: 40,
    layoutItems: mapValues(website.layoutItems, paymentWidgetMigration)
  };
}
